import { render, staticRenderFns } from "./ReviewProcessFlow.vue?vue&type=template&id=8528da64&scoped=true&"
import script from "./ReviewProcessFlow.vue?vue&type=script&lang=js&"
export * from "./ReviewProcessFlow.vue?vue&type=script&lang=js&"
import style0 from "./ReviewProcessFlow.vue?vue&type=style&index=0&id=8528da64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8528da64",
  null
  
)

export default component.exports